export default {
  "button.add": "Agregar",
  "button.addTransaction": "Agregar transacción",
  "button.delete": "Eliminar",
  "button.edit": "Editar",
  "button.login": "Iniciar sesión",
  "category.name": "Nombre",
  "categoryModal.titleModalAdd": "Añadir categoría",
  "categoryModal.titleModalEdit": "Editar categoria",
  "date.april": "abril",
  "date.august": "agosto",
  "date.december": "diciembre",
  "date.february": "febrero",
  "date.friday": "Vi",
  "date.january": "enero",
  "date.july": "julio",
  "date.june": "junio",
  "date.march": "marzo",
  "date.may": "mayo",
  "date.monday": "L",
  "date.november": "noviembre",
  "date.october": "octubre",
  "date.saturday": "Sa",
  "date.september": "septiembre",
  "date.sunday": "Do",
  "date.thuesday": "Ma",
  "date.thursday": "Ju",
  "date.wednesday": "Mi",
  "error.incorrectEmail":
    "Por favor, introduzca un correo electrónico correcta",
  "error.incorrectPassword": "Por favor complete una contraseña",
  "form.incomeExpense": "Ingresos/Gastos",
  "form.selectMonth": "Selecciona una fecha",
  "login.fieldEmail": "Correo electrónico",
  "login.fieldPassword": "Contraseña",
  "login.linkCreateAccount": "Crea una cuenta aquí",
  "login.noAccount": "¿No tienes cuenta?",
  "login.titleLogin": "Iniciar sesión",
  "navigation.categories": "Categorías",
  "navigation.overview": "Tablero",
  "navigation.logout": "Cerrar sesión",
  "navigation.transactions": "Transacciónes",
  "notifications.errorFillInAllFields": "Por favor rellene el formulario",
  "notifications.errorLogin": "Error con inicio de sesión",
  "notifications.errorLogout": "Algo salió mal para desconectarte.",
  "notifications.successLogin": "Iniciar sesión es un éxito",
  "notifications.successLogout": "Cerrar sesión es un éxito",
  "signup.goBackTo": "Volver a",
  "signup.titleSignup": "Regístrate",
  "table.expense": "Gastos",
  "table.income": "Ingresos",
  "table.noTotalsTracked": "No {0} seguido",
  "table.totals": "Totales",
  "transaction.amount": "Cantidad",
  "transaction.category": "Categoría",
  "transaction.date": "Fecha",
  "transaction.name": "Nombre",
  "transactionModal.title": "Agregar transacción",
  "button.addCategory": "Añadir categoría",
  "form.fieldPassword": "Contraseña",
  "form.fieldEmail": "Coreo electronico",
  "navigation.settings": "Configuraciones",
  "form.chooseLanguage": "Elige idioma",
  "update.newVersionDetected": "Nueva versión detectada.",
  "update.reload": "Recargar",
  "export.exportCSV": "Exportar CSV",
  "authentication.loggedIn": "Conectado: ",
};
